import { render, staticRenderFns } from "./InputNumericalFormula.vue?vue&type=template&id=71839c4a&scoped=true&lang=pug&"
import script from "./InputNumericalFormula.vue?vue&type=script&lang=ts&"
export * from "./InputNumericalFormula.vue?vue&type=script&lang=ts&"
import style0 from "./InputNumericalFormula.vue?vue&type=style&index=0&id=71839c4a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71839c4a",
  null
  
)

export default component.exports